import { FeatureFlag } from '@ps/web-core-enums';
import { select } from '@ps/web-core-store';
import type { RootState } from '@ps/web-core-store';
import { integrationTesting } from '@ps/web-core-utils';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useStore } from 'react-redux';

// TODO: WP-5063 Refactor into a Provider to be reused in Stars Web
export const SentryInit = () => {
  const { getState } = useStore<RootState>();

  useEffect(() => {
    const { sentryDsn, sentrySampleRate, sentryEnvironment } = select.config.get(getState());
    if (
      !Sentry.isInitialized() &&
      !integrationTesting &&
      sentryDsn &&
      select.feature.check(getState(), FeatureFlag.EnableSentry)
    ) {
      Sentry.init({
        dsn: sentryDsn,
        integrations: [Sentry.browserTracingIntegration()],
        environment: sentryEnvironment,
        release: window.version,
        tracesSampleRate: sentrySampleRate
      });
    }
  }, [getState]);

  return null;
};

export default SentryInit;
